function buildHash(scene: number, slide: number) {
  let hash = "#";
  if (typeof scene === "number") {
    hash = hash + "scene" + scene;
  }
  if (typeof slide === "number") {
    if (scene !== undefined) hash += "-";
    hash = hash + "slide" + slide;
  }
  return hash;
}
export default buildHash;
